class State {
  child = null;
  constructor(child) {
    this.child = child;
  }
  nextState = () => this.child;
  autocomplete = () => null;
  toString = () => `BASE -> ${this.child ? this.child.toString() : "null"}`;
}
export default State;
//# sourceMappingURL=State.js.map